import React, { useEffect, useCallback } from 'react';
import Camera, { FACING_MODES } from 'react-html5-camera-photo';
import { FaRegWindowClose } from 'react-icons/fa';

//services
import AppChargerDetailsService from '../AppChargerDetailsService';

//global components
import { LoadingSpinner } from '../../../shared';

//hooks
import { useCloudinary } from '../../../shared/Cloudinary/hook/useCloudinary';

//helpers
import { uuid } from '../../../shared/Helpers';

//styles
import {
  ModalStyles,
  ModalContainerStyles,
  ModalHeaderStyles,
  ModalContentStyles,
  ModalItemStyles,
  ButtonDivGreyStyles,
  ModalNoteStyles,
} from '../../../SharedStyles';

const BrowerCameraModal = (props) => {
  const { strings } = AppChargerDetailsService;
  const { charger, successUpload } = props;

  const { cloudData, uploadImage, imageLoading } = useCloudinary({
    preset: 'charger_images',
    tags: [props.charger.iotHubDeviceId],
  });

  const closeModal = () => {
    props.handleModalClose();
  };

  const postImage = useCallback(async () => {
    let updatedCharger = { ...charger };
    let newImage = {
      approved: false,
      imagePath: cloudData.secure_url,
      id: uuid(),
    };
    updatedCharger.images.push(newImage);
    await AppChargerDetailsService.updateCSOChargerSlider(updatedCharger);
    successUpload();
  }, [charger, cloudData, successUpload]);

  useEffect(() => {
    if (cloudData) {
      postImage();
    }
    // eslint-disable-next-line
  }, [cloudData]);

  const openDialog = () => {
    document.getElementById('inputUpload').click();
  };

  return (
    <ModalStyles>
      {imageLoading && <LoadingSpinner />}
      <ModalContainerStyles>
        {/* Header Bar */}
        <ModalHeaderStyles>
          <h2 className='Title'>{strings.photoTitle}</h2>
          <FaRegWindowClose className='Close' onClick={closeModal} />
        </ModalHeaderStyles>
        {/* Content Section */}
        <ModalContentStyles>
          {/* Section */}
          <ModalItemStyles padding='0 10px'>
            <p>{strings.photoContent}</p>
          </ModalItemStyles>
          {/* Section */}
          <ModalItemStyles padding='0 10px'>
            <p>
              <strong>{strings.photoHint}</strong> {strings.photoHintContent}
            </p>
          </ModalItemStyles>
        </ModalContentStyles>
        <ModalItemStyles padding='0 10px'>
          <Camera
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            isImageMirror={false}
            onTakePhoto={(dataUri) => {
              uploadImage(dataUri);
            }}
          />
        </ModalItemStyles>
        <input
          id='inputUpload'
          type='file'
          hidden
          accept='image/*'
          onChange={uploadImage}
        />
        <ModalNoteStyles>{strings.or}</ModalNoteStyles>
        <ButtonDivGreyStyles onClick={openDialog}>
          {strings.photoBrowse}
        </ButtonDivGreyStyles>
      </ModalContainerStyles>
    </ModalStyles>
  );
};

export default BrowerCameraModal;
